import { asyncHandler } from '../../async-handler';
import store from '../../../../store/store';
import { RequestInfo } from '../../../../interfaces/RequestInfo';
import { USER_CHANNELS_API } from '../../../constants/central-api';
import { applicationJSONBodyBuilder } from '../../../utils/body-builder';

export default async function request_channel_verification_code_api_call(
  bodyContent: any
) {
  const userID = store.getState().user.profile?.user_id;
  const accessToken = store.getState().auth.authorization.accessToken;
  const isWhiteLabel = store.getState().UI?.isWhiteLabel;
  let sellerToken: string;
  if (isWhiteLabel) {
    sellerToken = accessToken?.currentWhiteLabelSellerToken;
  } else {
    sellerToken = accessToken?.sellerToken;
  }

  const requestInfo: RequestInfo = {
    url: `${USER_CHANNELS_API(userID)}/send-verification`,
    method: 'POST',
    body: applicationJSONBodyBuilder(bodyContent),
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: accessToken.type + ' ' + sellerToken,
    },
  };

  const actionType = 'REQUEST_CHANNEL_VERIFICATION_CODE';
  const customMsg = 'Requesting channel verification code';

  const res: any = await asyncHandler(
    requestInfo,
    actionType,
    customMsg,
    false
  );
  const response = res?.data;

  if (res.actionType === actionType && response.success === true) {
    return true;
  } else {
    return false;
  }
}
